import Map from '../components/Map';
import NavBar from '../components/NavBar';

export default function SearchPlace() {
  return (
    <>
      <Map />
      <NavBar />
    </>
  );
}
